import Toastify from 'spc-general-component/lib/Toastify'
import get from 'lodash/get'
import replace from 'lodash/replace'
import findIndex from 'lodash/findIndex'
import productModule from '../modules/product'
import listModule from '../modules/list'
import { fetchPOST } from '../api/fetchers'
import  concat  from 'lodash/concat'
import  moment from 'moment'
import {  localStorage } from '../utils'
import orderBy from 'lodash/orderBy'
import isEmpty from 'lodash/isEmpty'
import toUpper from 'lodash/toUpper'
import filter from 'lodash/filter'
import shuffle from 'lodash/shuffle'
import slice from 'lodash/slice'
import toNumber from 'lodash/toNumber'
import { find } from 'lodash'
import isUndefined from 'lodash/isUndefined'

const HOST = process.env.REACT_APP_HOST || ''
const WS_HOST = process.env.REACT_APP_WS_HOST || ''
const COMPANY_CODE = process.env.REACT_APP_COMPANY_CODE || ''
const ORG_CODE = process.env.REACT_APP_ORG_CODE || ''
const WAREHOUSE_CODE = process.env.REACT_APP_WAREHOUSE_CODE || ''
const CREATE_BY = process.env.REACT_APP_CREATE_BY || ''
const ShoppingStorage = process.env.REACT_APP_SHPOPPING_STORAGE || 'SPC-SHOPPING-LIST'
const GROUP_GENERAL_CODE = process.env.REACT_APP_GROUP_GENERAL_CODE || 'G1'

const getProductListAction = () => {
  return async (dispatch,getState) => {
    try {
      const customerProfile = get(getState().customer, 'customerProfile', [])
      const GROUP_CODE = isEmpty(customerProfile) ? GROUP_GENERAL_CODE : customerProfile?.customergroupcode
      
      const response = await fetchPOST({
        useMock: false,
        jsonMock: `GetProductList.json`,
        // url: `${HOST}/b2b/v4/Product/list`,
        url: `${WS_HOST}/b2b/v4/Product/list`,
          data: {
            "orgcode":ORG_CODE,
            "companycode": COMPANY_CODE,
            "warehousecode":WAREHOUSE_CODE,
            "groupcode": GROUP_CODE,
            "showpagecode": ``,
            "status":"N",
            "similarproductflag": "N"
        }
      })

      const productList = get(response, 'data.result', []).map(product => {
        return ({
          ...product,
          seqn: toNumber(product.seqn)
        })
      })

      dispatch(productModule.setData({
        data: {
          'productList': orderBy(filter(productList,(product) => {return toUpper(product.status) === toUpper('N')}), ['categorycode', 'seqn'], ['asc', 'asc'])
        }
      }))

      dispatch(listModule.setDataList({
        data: {
          'flashsaleData': get(response, 'data.flashsalestab', [])
        }
      }))

    } catch (error) {
      Toastify({
        position: 'center', // left, right, center is default
        type: 'ERROR', // ERROR, WARNING, LOADING, INFO
        message: 'API Get Product List Action is not working',
        closeTime: 5 // Seconds
      })
    }
  }
}

const getProductDetailAction = ({ productCode, onFunctionCallBack= () => {} }) => {
  return async (dispatch, getState) => {
    try {
      const customerProfile = get(getState().customer, 'customerProfile', [])
      const GROUP_CODE = isEmpty(customerProfile) ? GROUP_GENERAL_CODE : customerProfile?.customergroupcode
      const response = await fetchPOST({
        useMock: false,
        jsonMock: `GetProduct${replace(productCode, 'http://', '')}.json`,
        // url: `${HOST}/b2b/v4/Product/list`,
        url: `${WS_HOST}/b2b/v4/Product/list`,
        data: {
          "orgcode":ORG_CODE,
          "companycode":COMPANY_CODE,
          "warehousecode":WAREHOUSE_CODE,
          "groupcode":GROUP_CODE,
          "status":"N",
          "productcode": productCode,
          "similarproductflag": "N"
      }
      })

      const productDetail = get(response, 'data.result[0]', {})
      onFunctionCallBack({ productDetail })

    } catch (error) {
      Toastify({
        position: 'center', // left, right, center is default
        type: 'ERROR', // ERROR, WARNING, LOADING, INFO
        message: 'API Get Product Detail Action is not working',
        closeTime: 5 // Seconds
      })
    }
  }
}

const removeProductViewListAction = () => {
  return async (dispatch, getState) => {
    try {
      const productViewList = get(getState().product, 'productViewList', [])
      productViewList.pop()

      dispatch(productModule.setData({
        data: {
          'productViewList': productViewList
        }
      }))
    } catch (error) {
      Toastify({
        position: 'center', // left, right, center is default
        type: 'ERROR', // ERROR, WARNING, LOADING, INFO
        message: 'API Update Product Detail Action is not working',
        closeTime: 5 // Seconds
      })
    }
  }
}

const updateProductDetailAction = ({ productDetail }) => {
  return async (dispatch, getState) => {
    try {
      const customerProfile = get(getState().customer, 'customerProfile', [])
      const GROUP_CODE = isEmpty(customerProfile) ? GROUP_GENERAL_CODE : customerProfile?.customergroupcode

      const {productcode} = productDetail
      const response = await fetchPOST({
        // url: `${HOST}/b2b/v4/Product/list`,
        url: `${WS_HOST}/b2b/v4/Product/list`,
        data: {
          "orgcode":ORG_CODE,
          "companycode":COMPANY_CODE,
          "warehousecode":WAREHOUSE_CODE,
          "groupcode":GROUP_CODE,
          "status":"N",
          "productcode": productcode,
          "similarproductflag": "N"
        }
      })
      const productDetailResponse = get(response, 'data.result[0]', {})
      const productViewList = get(getState().product, 'productViewList', [])
      productViewList.push({ ...productDetailResponse })

      dispatch(productModule.setData({
        data: { 'productViewList': productViewList }
      }))

    } catch (error) {
      Toastify({
        position: 'center', // left, right, center is default
        type: 'ERROR', // ERROR, WARNING, LOADING, INFO
        message: 'API Update Product Detail Action is not working',
        closeTime: 5 // Seconds
      })
    }
  }
}

const getProductRelativeAction = ({ productcode,similarproduct }) => {
  return async (dispatch, getState) => {
    try {
      const productList = get(getState().product, 'productList', [])
      const productViewList = get(getState().product, 'productViewList', [])
      const viewIndex = findIndex(productViewList, product => { return product?.productcode === productcode })

      const filterProductByCategory = filter(productList,(product) => {
              return (get(product,'defaultshowpagecode','P01') === get(productViewList[viewIndex],'defaultshowpagecode','P01') && toUpper(product.status) === toUpper('N'))
            })
      const shuffleProduct = shuffle(filterProductByCategory)
      dispatch(productModule.setData({
        data: {
          'productViewList': productViewList,
          'ProductRelateList': slice(shuffleProduct,0,30)
        }
      }))

    } catch (error) {
      Toastify({
        position: 'center', // left, right, center is default
        type: 'ERROR', // ERROR, WARNING, LOADING, INFO
        message: 'API Get Product Relative Action is not working',
        closeTime: 5 // Seconds
      })
    }
  }
}

const getProductRecommentAction = () => {
  return async (dispatch, getState) => {
    try {
      const productList = get(getState().product, 'productList', [])
      const shoppingCart = getState().product.shoppingCart

      let combineRelateCode = []
      shoppingCart.map((item) => {
        const filterProductByCategory = filter(productList,(product) => {
          return (get(product,'defaultshowpagecode','P01') === get(item,'defaultshowpagecode','P01') && toUpper(product.status) === toUpper('N'))
        })
        const shuffleProduct = shuffle(filterProductByCategory)
        combineRelateCode = concat(combineRelateCode,...slice(shuffleProduct,0,30))
      })

      dispatch(productModule.setData({
        data: {
          'productRecommentList': shuffle(combineRelateCode)
        }
      }))

    } catch (error) {
      Toastify({
        position: 'center', // left, right, center is default
        type: 'ERROR', // ERROR, WARNING, LOADING, INFO
        message: 'API Get Product Recomment Action is not working',
        closeTime: 5 // Seconds
      })
    }
  }
}

const getCouponListAction = () => {
  return async (dispatch,getState) => {
    try {
      const customerProfile = get(getState().customer,'customerProfile',{})
      const responseListCoupon = await fetchPOST({
        useMock: false,
        jsonMock: `GetCouponList.json`,
        url: `${HOST}/customer/listcouponmaster`,
        data: {
            "orgcode": ORG_CODE,
            "companycode": COMPANY_CODE,
            "couponcode": "",
            "couponprefix": "",
            "status": "N",
            "fromdate": moment().format('YYYY-MM-DD')
        }
      })

      let couponLists =  get(responseListCoupon, 'data.result', [])
        for (const couponList of couponLists) {
          await fetchPOST({
            useMock: false,
            jsonMock: `GetOrderHistory.json`,
            url: `${HOST}/customer/insertcustomercoupon`,
            data: {
                "orgcode": ORG_CODE,
                "companycode": COMPANY_CODE,
                "customercode": customerProfile?.customercode,
                "couponcode": couponList?.couponprefix,
                "couponname": couponList?.couponname,
                "coupontype": couponList?.coupontype,
                "couponvalue": couponList?.cashvalue,
                "percentvalue": couponList?.percentvalue,
                "minimum_bill_amount":couponList?.minimum_bill_amount,
                "startdate": couponList?.activedate,
                "enddate": couponList?.expiredate,
                "createby": CREATE_BY,
                "couponprefix":couponList?.couponprefix,
                "couponcodehead":couponList?.couponcode
            }
          })
      }

      const responseUserListCoupon = await fetchPOST({
        useMock: false,
        jsonMock: `GetCouponList.json`,
        url: `${HOST}/customer/listcustomercoupon`,
        data: {
            "orgcode": ORG_CODE,
            "companycode": COMPANY_CODE,
            "customercode": customerProfile?.customercode,
            "couponcode": "",
            "status": "0",
            "currentdate": moment().format('YYYY-MM-DD')
        }
      })

      dispatch(productModule.setData({
        data: {
          'couponList': get(responseUserListCoupon, 'data.result', [])
        }
      }))
    } catch (error) {
      Toastify({
        position: 'center', // left, right, center is default
        type: 'ERROR', // ERROR, WARNING, LOADING, INFO
        message: 'API Get Coupon List Action is not working',
        closeTime: 5 // Seconds
      })
    }
  }
}

const getOrderHistoryListAction = () => {
  return async (dispatch, getState) => {
    try {
      const limitPage = 2
      const customerProfile = get(getState().customer,'customerProfile',{})
      const responseOrderList = await fetchPOST({
        useMock: false,
        jsonMock: `GetOrderHistory.json`,
        url: `${HOST}/b2b/v3/Order/listOrdersbycustomer`,
        data: {
            "orgcode":ORG_CODE,
            "companycode":COMPANY_CODE,
            "customercode": customerProfile?.b2bcustomercode,
            "ephone": customerProfile?.loginWith ? customerProfile?.email : customerProfile?.telephone
        }
      })
      let orderLists =  get(responseOrderList,'data.result',[])
      // let orderSlice = orderLists.slice(0,limitPage)
      //   for (const orderList of orderSlice) {
      //     const responseOrderDetail = await fetchPOST({
      //       useMock: false,
      //       jsonMock: `GetOrderHistory.json`,
      //       url: `${HOST}/b2b/v2/ReportOrder/getReportDataV1`,
      //       data: {
      //           "companycode":COMPANY_CODE,
      //           "documentno": orderList.documentno
      //       }
      //     })
      //     if(orderList.documentno === responseOrderDetail.data.head_bill.documentno){
      //       orderList['orderDetail'] = responseOrderDetail.data
      //     }
          
      // }
      dispatch(listModule.setDataList({
        data: {
          'orderHistoryList': orderLists
        }
      }))
    } catch (error) {
      Toastify({
        position: 'center', // left, right, center is default
        type: 'ERROR', // ERROR, WARNING, LOADING, INFO
        message: 'API Get Order History List Action is not working',
        closeTime: 5 // Seconds
      })
    }
  }
}

const getOrderHistoryPaginateListAction = ({currentPage}) => {
  return async (dispatch, getState) => {
    try {
      const limitPage = 2
      const orderHistoryList = get(getState().list,'orderHistoryList',[])
      let orderSlice = orderHistoryList.slice(currentPage,(limitPage+currentPage))
      for (const orderList of orderSlice) {
          const responseOrderDetail = await fetchPOST({
            useMock: false,
            jsonMock: `GetOrderHistory.json`,
            url: `${HOST}/b2b/v2/ReportOrder/getReportDataV1`,
            data: {
                "companycode":COMPANY_CODE,
                "documentno": orderList.documentno
            }
          })
          if(orderList.documentno === responseOrderDetail.data.head_bill.documentno){
            orderList['orderDetail'] = responseOrderDetail.data
          }    
      }
      dispatch(listModule.setDataList({
        data: {
          'orderHistoryList': orderHistoryList
        }
      }))
    } catch (error) {
      Toastify({
        position: 'center', // left, right, center is default
        type: 'ERROR', // ERROR, WARNING, LOADING, INFO
        message: 'API Get Order History List Action is not working',
        closeTime: 5 // Seconds
      })
    }
  }
}

const getOrderHistoryDetailListAction = ({documentNo}) => {
  return async (dispatch, getState) => {
    try {

      const orderHistoryList = get(getState().list,'orderHistoryList',[])
     
      const responseOrderDetail = await fetchPOST({
        useMock: false,
        jsonMock: `GetOrderHistory.json`,
        url: `${HOST}/b2b/v2/ReportOrder/getReportDataV1`,
        data: {
            "companycode":COMPANY_CODE,
            "documentno": documentNo
        }
      })
             
      const orderHistoryDetail = get(responseOrderDetail,'data',{})

      let indexOrderDetail = orderHistoryList.findIndex(item => item.documentno === documentNo)
      orderHistoryList[indexOrderDetail]['orderDetail'] = orderHistoryDetail
      
      dispatch(listModule.setDataList({
        data: {
          'orderHistoryList': orderHistoryList
        }
      }))
    } catch (error) {
      Toastify({
        position: 'center', // left, right, center is default
        type: 'ERROR', // ERROR, WARNING, LOADING, INFO
        message: 'API Get Order History List Action is not working',
        closeTime: 5 // Seconds
      })
    }
  }
}

const getProductSearchListAction = ({ wordSearch }) => {
  return async (dispatch, getState) => {
    try {
      const customerProfile = get(getState().customer, 'customerProfile', [])
      const GROUP_CODE = isEmpty(customerProfile) ? GROUP_GENERAL_CODE : customerProfile?.customergroupcode
      
      const response = await fetchPOST({
        useMock: false,
        jsonMock: `GetProductList.json`,
        // url: `${HOST}/b2b/v4/Product/list`,
        url: `${WS_HOST}/b2b/v4/Product/list`,
        data: {
          "orgcode":ORG_CODE,
          "companycode":COMPANY_CODE,
          "warehousecode":WAREHOUSE_CODE,
          "groupcode":GROUP_CODE,
          "status":"N",
          "search":wordSearch,
          "similarproductflag": "N"
        }
      })
  
      dispatch(listModule.setDataList({
        data: {
          'productSearchList': filter(get(response, 'data.result', []),(product) => {return toUpper(product.status) === toUpper('N')})
        }
      }))
    } catch (error) {
      Toastify({
        position: 'center', // left, right, center is default
        type: 'ERROR', // ERROR, WARNING, LOADING, INFO
        message: 'API Get Product Search List Action is not working',
        closeTime: 5 // Seconds
      })
    }
  }
}

const getBestSellerProductSearchListAction = () => {
  return async (dispatch, getState) => {
    try {
      const customerProfile = get(getState().customer, 'customerProfile', [])
      const GROUP_CODE = isEmpty(customerProfile) ? GROUP_GENERAL_CODE : customerProfile?.customergroupcode
      
      const response = await fetchPOST({
        useMock: false,
        jsonMock: `GetProductList.json`,
        // url: `${HOST}/b2b/v4/Product/list`,
        url: `${WS_HOST}/b2b/v4/Product/list`,
        data: {
          "orgcode":ORG_CODE,
          "companycode":COMPANY_CODE,
          "warehousecode":WAREHOUSE_CODE,
          "groupcode":GROUP_CODE,
          "status":"N",
          "bestsellerpage": "Y",
          "showpagecode": "",
          "similarproductflag": "N"
        }
      })
  
      dispatch(listModule.setDataList({
        data: {
          'productSearchList': get(response, 'data.result', [])
        }
      }))
    } catch (error) {
      Toastify({
        position: 'center', // left, right, center is default
        type: 'ERROR', // ERROR, WARNING, LOADING, INFO
        message: 'API Get Product Search List Action is not working',
        closeTime: 5 // Seconds
      })
    }
  }
}

const getProductBrandSearchListAction = ({brandName}) => {
  return async (dispatch, getState) => {
    try {
      const customerProfile = get(getState().customer, 'customerProfile', [])
      const GROUP_CODE = isEmpty(customerProfile) ? GROUP_GENERAL_CODE : customerProfile?.customergroupcode
      
      const response = await fetchPOST({
        useMock: false,
        jsonMock: `GetProductList.json`,
        url: `${HOST}/b2b/v4/Product/list`,
        data: {
          "orgcode":ORG_CODE,
          "companycode":COMPANY_CODE,
          "warehousecode":WAREHOUSE_CODE,
          "status":"N",
          "groupcode":GROUP_CODE,
          "brandcode":brandName
        }
      })

      let productList = get(response, 'data.result', [])

      const productListOrdered = productList.map(product => {
        const { showpagedtl, seqn } = product
        const showpage = find(showpagedtl, page => { return page.showpagecode === 'P01' })
        let orderSq = seqn
        if (!isUndefined(showpage)) {
          orderSq = toNumber(showpage.seqn)
        } else {
          orderSq = 99999
        }
        return ({
          ...product,
          orderSq: orderSq
        })
      })

      dispatch(listModule.setDataList({
        data: {
          'productSearchList':  orderBy(productListOrdered, ['orderSq'], ['asc'])
        }
      }))
    } catch (error) {
      Toastify({
        position: 'center', // left, right, center is default
        type: 'ERROR', // ERROR, WARNING, LOADING, INFO
        message: 'API Get Product Brand List Action is not working',
        closeTime: 5 // Seconds
      })
    }
  }
}

const onClearCartAction = () => {
  return async (dispatch) => {
    try {
      localStorage.remove(ShoppingStorage)
      dispatch(productModule.setData({
        data: {
          'shoppingCart': []
        }
      }))
      
    } catch (error) {
      Toastify({
        position: 'center', // left, right, center is default
        type: 'ERROR', // ERROR, WARNING, LOADING, INFO
        message: 'Clear ไม่สำเร็จ',
        closeTime: 5 // Seconds
      })
    }
  }
}

const checkCouponAction = ({couponcode='', amount=0, transportprice=0, coupon_type=undefined, onCallBackAction = () =>{}}) => {
  return async (dispatch,getState) => {
    try {
      const customerProfile = get(getState().customer,'customerProfile',{})
      const shoppingCart = get(getState().product, 'shoppingCart', [])
      let details = []
      for (let item of shoppingCart){
          details.push({
            'productcode'  : item?.productcode,
            'quantity'     : item?.orderAmount,
            'unit_price'   : item?.special_priceforsales,
            'buyfree'      : 'B',
            'promoteto'    : '',
          })
      }

      const response = await fetchPOST({
        useMock: false,
        jsonMock: `GetCouponList.json`,
        url: `${HOST}/b2b/v5/Promotion/checkCoupon`,
        data: {
          "orgcode":ORG_CODE,
          "companycode":COMPANY_CODE,
          "couponcode":couponcode,
          "address_type": "",
          "amount":amount,
          "transportprice":transportprice,
          "groupcode":customerProfile?.customergroupcode,
          "customercode":customerProfile?.customercode,
          "details":details,
          "coupon_type": coupon_type
        }
      })

      const coupon = get(response, 'data.result', null)
      const unUsable = get(response, 'data.usedCouponFlag', false)
      const freeproducts = get(response, 'data.freeproducts', [])

      onCallBackAction({
        coupon: coupon ? {...coupon,couponprefix:couponcode} : null,
        unUsable: unUsable,
        freeproducts: freeproducts
      })
    } catch (error) {
      Toastify({
        position: 'center', // left, right, center is default
        type: 'ERROR', // ERROR, WARNING, LOADING, INFO
        message: 'API Get Check Coupon Action is not working',
        closeTime: 5 // Seconds
      })
    }
  }
}

const reorderAction = () => {
  return async (dispatch) => {
    try {
      localStorage.remove(ShoppingStorage)
      dispatch(productModule.setData({
        data: {
          'shoppingCart': []
        }
      }))
      
    } catch (error) {
      Toastify({
        position: 'center', // left, right, center is default
        type: 'ERROR', // ERROR, WARNING, LOADING, INFO
        message: 'Clear สินค้าที่ค้างไม่สำเร็จ',
        closeTime: 5 // Seconds
      })
    }
  }
}


const repleaceProductAction = ({detail_bill }) => {
  return async (dispatch,getState) => {
    try {
      //const shoppingCart = get(getState().product, 'shoppingCart', [])
      const productList  = get(getState().product, 'productList', [])
      let details = []

      const filterDetailbill = filter(detail_bill,(y) => {
        return  toNumber(y.netamountdetail) > 0
      })

      for (let item of filterDetailbill){
        const filterProduct = find(productList,(x) => {
          return x.productcode === item?.productcode 
        })

        let unknownProduct = []
        if (filterProduct){
          filterProduct.orderAmount = item?.quantity
          details.push(filterProduct)
        }else{
          unknownProduct.push(item?.productname)
        }
      }
      dispatch(productModule.setData({
        data: {
          'shoppingCart': [...details]
        }
      }))
    } catch (error) {
      console.log(error)
      Toastify({
        position: 'center', // left, right, center is default
        type: 'ERROR', // ERROR, WARNING, LOADING, INFO
        message: 'API Get Check  Action is not working',
        closeTime: 5 // Seconds
      })
    }
  }
}

export {
  getProductDetailAction,
  getProductListAction,
  updateProductDetailAction,
  removeProductViewListAction,
  getProductRelativeAction,
  getProductRecommentAction,
  getCouponListAction,
  getOrderHistoryListAction,
  getProductSearchListAction,
  onClearCartAction,
  getBestSellerProductSearchListAction,
  getOrderHistoryPaginateListAction,
  getOrderHistoryDetailListAction,
  checkCouponAction,
  reorderAction,
  repleaceProductAction,
  getProductBrandSearchListAction
}